import { useQuery } from "react-query";
import Query from "./../querybuilder/Query";
const useOriginalId = (id?: string) => {
  return useQuery(
    `original-${id}`,
    () => {
      return Query(id)
        .attributes("id")
        .fetchValues<{
          id: string;
        }>()
        .then((value) => (value[0] ? value[0].id : undefined));
    },
    { staleTime: 10 * 60 * 1000, cacheTime: 10 * 6 * 1000 }
  );
};
export default useOriginalId;
